import BackroomSection from './BackroomSection';
import BackroomSectionContainer from './BackroomSection.container';

export default BackroomSectionContainer(BackroomSection);
